import React, {useMemo} from "react"
import {useSiren} from "./SirenContext";
import {Layout} from "./Layout";
import {ImportHistory} from "./subpages/ImportHistory";
import {NewImport} from "./subpages/NewImport";
import {ImportManagementProvider} from "./ImportManagementContext";
import { AlertLog } from "./subpages/AlertLog";
import {AlertCreate} from "./subpages/AlertCreate";



export function Alerts() {

    const {subMenuCurrent, clientID} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "log":
                return <AlertLog/>
            case "create":
                return <AlertCreate/>
        }

        return null
    }, [subMenuCurrent])

    return (
        <Layout menuCurrent={"alert"}>
            {page}
        </Layout>
    )


}